import Topheader from "./topheader";
import Bottumheader from "./bottumheader";

function Header() {
  return (
    <div className="header">
      <Topheader />
      <Bottumheader />
    </div>
  );
}

export default Header;
